import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';

import { MgImageModule } from '@app/src/app/components/MgImage';
import { BadgeDialogService } from '@app/src/app/dialog/BadgeDialog/BadgeDialog.service';
import { MgPipesModule } from '@app/src/app/pipes';

import { BadgeDialog } from './BadgeDialog.component';

@NgModule({
  imports: [
    // Minga dependencies
    MgImageModule,
    MgPipesModule,

    // External dependencies
    CommonModule,
    MatDialogModule,
  ],

  declarations: [BadgeDialog],
  exports: [BadgeDialog],
  providers: [BadgeDialogService],
})
export class BadgeDialogModule {}
